import React from 'react';
import { Modal, Box, Typography, Stack, useMediaQuery, useTheme } from '@mui/material';
import CustomButton from '../CustomButton';


const CustomModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  children,
  confirmText = "Confirmer",
  cancelText = "Annuler",
  showConfirm = true,
  showCancel = true,
  disableConfirm = false,
  loading = false
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: isMobile ? '90vw' : 600,
    maxHeight: isMobile ? '85vh' : null,
    bgcolor: 'white',
    border: '1px solid white',
    borderRadius: '5px',
    boxShadow: 0,
    p: 3,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box sx={styleModal}>
        <Stack spacing={4}>
          {title && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant="subtitle1">{title}</Typography>
            </Box>
          )}
          {description && (
            <Box dir="ltr">
              <Typography align="center" variant="body2">{description}</Typography>
            </Box>
          )}

          {children && (
            <Box >
              {children}
            </Box>
          )}

          <Stack direction="row" spacing={2} justifyContent="center">
            {showCancel && <CustomButton type="secondaire" buttonText={cancelText} onClick={onClose} />}

            {showConfirm && (
              <CustomButton
                type="primaire"
                buttonText={confirmText}
                onClick={onConfirm}
                loading={loading}
                disabled={disableConfirm}
              />
            )}
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default CustomModal;
